<template>
    <div class="logo text-3xl px-1">
        😈
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: 'Logo',
})
</script>

<style scoped>

</style>
